import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../Config";
import ContentHeader from "../../ShareElements/ContentHeader/ContentHeader";
import ImagePreloader from "../../ShareElements/ImagePreloader/ImagePreloader";
import DesktopView from "./Views/DesktopView";
import MobileView from "./Views/MobileView";

const CreateJobs = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const [HeadText, setHeadText] = useState(translateText("new_vacancy"));
  const [EducationOptions, setEducationOptions] = useState([]);
  const [Locations, setLocations] = useState([]);
  const [Languages, setLanguages] = useState();

  useEffect(() => {
    fetchEducations();
    fetchLocations();
    fetchAllLanguages();
    if (
      window.innerWidth > 450 &&
      document.getElementById("nav-/createVacancies") !== null
    ) {
      //executed on component mount.
      document
        .getElementById("nav-/createVacancies")
        .classList.add("active-node");
      return () => {
        //executed on component unmount.
        document
          .getElementById("nav-/createVacancies")
          .classList.remove("active-node");
      };
    }
  }, []);

  const fetchAllLanguages = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/find-all-languages",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Langs = [];
        Res.data.map((Lang) => {
          Langs.push({
            name: Lang.name,
            id: Lang.id,
          });
        });
        setLanguages(Langs);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchEducations = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/find-all-educations",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Educations = [];
        Res.data.map((EdItem, i) => {
          Educations.push({
            name: EdItem,
            id: "education-" + i,
          });
        });
        setEducationOptions(Educations);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchLocations = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/find-all-cities",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Locations = [];
        Res.data.map((Item, i) => {
          Locations.push({
            name: Item,
            id: "location-" + i,
          });
        });
        setLocations(Locations);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  return (
    <div className="main-content">
      <ImagePreloader Images={[]} />
      <ContentHeader
        LangData={props.LangData}
        PageName={translateText("create-vacancies")}
      />
      {window.innerWidth > 450 ? (
        <DesktopView
          HeadText={HeadText}
          UserInfo={props.UserInfo}
          EducationOptions={EducationOptions}
          Locations={Locations}
          Languages={Languages ? Languages : []}
          IsJob
          JPAType="job"
          LangData={props.LangData}
        />
      ) : (
        <MobileView
          HeadText={HeadText}
          UserInfo={props.UserInfo}
          EducationOptions={EducationOptions}
          Locations={Locations}
          Languages={Languages ? Languages : []}
          IsJob
          JPAType="job"
          LangData={props.LangData}
        />
      )}
    </div>
  );
};

export default CreateJobs;
